import { ComponentProps } from 'react'

import { TSearchFilter, useSearchFilterStore } from '@/entities/map'
import { cn } from '@/shared/lib'
import { Chip, Icon } from '@/shared/ui'

import { Filter } from '../../model/filter'
import { FilterDialogTrigger } from '../filter-dialog'

type Field = keyof TSearchFilter

const filters: {
  title: string
  type: Filter
  field: Field[]
  width: number
}[] = [
  {
    title: '방 개수',
    type: Filter.RoomCounts,
    field: ['roomCounts'],
    width: 79,
  },
  {
    title: '가격',
    type: Filter.UsingFee,
    field: ['minUsingFee', 'maxUsingFee'],
    width: 65,
  },
  {
    title: '건물 유형',
    type: Filter.PropertyTypes,
    field: ['propertyTypes'],
    width: 90,
  },
  {
    title: '평수',
    type: Filter.PyeongSizes,
    field: ['pyeongSizes'],
    width: 65,
  },
  {
    title: '층수',
    type: Filter.Floors,
    field: ['floors'],
    width: 65,
  },
  {
    title: '옵션',
    type: Filter.Options,
    field: ['popularOptions', 'basicOptions', 'additionalOptions'],
    width: 65,
  },
  {
    title: '할인',
    type: Filter.RoomDiscounts,
    field: ['roomDiscounts'],
    width: 65,
  },
]

export const FilterMenus = () => {
  const hasChanged = useSearchFilterStore(state => state.hasChanged)
  const count = useSearchFilterStore(state => state.count)
  const hasFilter = count > 0

  return (
    <div className="mr-4 flex gap-1.5">
      <FilterDialogTrigger>
        <Chip
          variant="outline"
          size="medium"
          shape="pill"
          selected={hasFilter}
          className="relative max-w-8"
        >
          <Icon name="filter" size={16} className="text-black" />
          <span className="sr-only">전체 필터</span>
          {hasFilter && (
            <span
              className={cn(
                'block h-4 w-4 rounded-full bg-purple-500 text-[9px] leading-2.5 font-semibold tracking-[-0.1px] text-white',
                'flex items-center justify-center',
                'absolute -top-0 -right-[7px]',
              )}
            >
              {count}
            </span>
          )}
        </Chip>
      </FilterDialogTrigger>
      {filters.map(({ title, type, field, width }) => (
        <FilterDialogTrigger
          key={type}
          target={type as ComponentProps<typeof FilterDialogTrigger>['target']}
        >
          <Chip
            variant="outline"
            size="medium"
            shape="pill"
            width={width}
            selected={hasChanged(field)}
            className="[&[data-state=open]_svg]:rotate-180"
            endIcon={
              <Icon
                name="arrow-bottom"
                className={cn('transition-transform duration-200')}
              />
            }
          >
            {title}
          </Chip>
        </FilterDialogTrigger>
      ))}
    </div>
  )
}
